import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/pos/lib/api";
import { rm, dt } from "@/pos/lib/format";

export default function TableBill() {
  const { id } = useParams();
  const [t, setT] = useState(null);
  const [shop, setShop] = useState({});
  useEffect(() => {
    Promise.all([api.get(`/tables/${id}`), api.get("/settings")]).then(([a, b]) => { setT(a.data); setShop(b.data); setTimeout(() => window.print(), 400); });
  }, [id]);
  if (!t) return <div className="p-6 text-sm">Memuatkan...</div>;
  const items = t.orders.flatMap((o) => o.items);
  return (
    <div className="mx-auto max-w-[300px] bg-white p-4 font-mono text-xs text-black" data-testid="table-bill">
      <div className="text-center"><div className="text-sm font-bold">{shop.shop_name}</div><div>{shop.address}</div><div>{shop.phone}</div></div>
      <div className="my-2 border-t border-dashed border-black" />
      <div className="flex justify-between"><span>BIL MEJA {t.number}</span><span>{dt(new Date().toISOString())}</span></div>
      <div>Order: {t.orders.map((o) => `#${o.number}`).join(", ")}</div>
      <div className="my-2 border-t border-dashed border-black" />
      {items.map((it, i) => <div key={i} className="flex justify-between"><span>{it.qty} x {it.name}</span><span>{rm(it.subtotal)}</span></div>)}
      <div className="my-2 border-t border-dashed border-black" />
      <div className="flex justify-between text-sm font-bold"><span>JUMLAH</span><span>{rm(t.amount)}</span></div>
      <div className="mt-3 text-center">Bil ini bukan resit rasmi. Sila bayar di kaunter.</div>
      <button onClick={() => window.print()} className="no-print mt-4 w-full rounded border border-black py-2" data-testid="bill-print-btn">Cetak</button>
    </div>
  );
}
